import { IClassname } from '@/lib/shared/model/classname';

export const FilterBar = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4706 20V2.375H13.8235C14.666 2.375 15.4739 2.73058 16.0696 3.36351C16.6653 3.99645 17 4.85489 17 5.75V12.875H16.6471C16.179 12.875 15.7302 13.0725 15.3992 13.4242C15.0683 13.7758 14.8824 14.2527 14.8824 14.75M7.47059 20V9.125M7.47059 9.125C8.12583 9.125 8.75423 8.84844 9.21756 8.35616C9.68088 7.86387 9.94118 7.19619 9.94118 6.5V2M7.47059 9.125C6.81535 9.125 6.18694 8.84844 5.72362 8.35616C5.26029 7.86387 5 7.19619 5 6.5V2M7.47059 2V7.625"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};
